"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMultiSelectHooks = exports.useSingleSelectHooks = exports.useComboboxHook = void 0;
var downshift_1 = require("downshift");
var shared_1 = require("./shared");
var useSelectStateReducers_1 = require("./useSelectStateReducers");
var useComboboxHook = function (args) {
    var initialSelectedItem = args.initialSelectedItem, isDisabled = args.isDisabled, _a = args.isMultiSelect, isMultiSelect = _a === void 0 ? false : _a, listItems = args.listItems, onChange = args.onChange, onInputChange = args.onInputChange, onInternalStateChange = args.onInternalStateChange, renderItemToString = args.renderItemToString, stateReducer = args.stateReducer;
    var useComboboxArgs = function () {
        if (isMultiSelect) {
            return {
                selectedItem: null,
            };
        }
        else {
            return {
                initialSelectedItem: initialSelectedItem,
            };
        }
    };
    var _b = (0, downshift_1.useCombobox)(__assign(__assign({}, useComboboxArgs()), { items: listItems, itemToString: renderItemToString, onSelectedItemChange: function (changes) {
            return (0, shared_1.sharedOnSelectedItemChange)(changes, isDisabled, onChange);
        }, onStateChange: function (state) {
            return (0, shared_1.sharedOnStateChange)(state, onInternalStateChange, onInputChange);
        }, stateReducer: stateReducer })), closeMenu = _b.closeMenu, getInputProps = _b.getInputProps, getItemProps = _b.getItemProps, getLabelProps = _b.getLabelProps, getMenuProps = _b.getMenuProps, getToggleButtonProps = _b.getToggleButtonProps, highlightedIndex = _b.highlightedIndex, inputValue = _b.inputValue, isOpen = _b.isOpen, openMenu = _b.openMenu, selectedItem = _b.selectedItem, selectItem = _b.selectItem;
    return {
        useComboboxControlProps: {
            closeMenu: closeMenu,
            getInputProps: getInputProps,
            getItemProps: getItemProps,
            getLabelProps: getLabelProps,
            getMenuProps: getMenuProps,
            getToggleButtonProps: getToggleButtonProps,
            highlightedIndex: highlightedIndex,
            inputValue: inputValue,
            isOpen: isOpen,
            openMenu: openMenu,
            selectedItem: selectedItem,
            selectItem: selectItem,
        },
    };
};
exports.useComboboxHook = useComboboxHook;
var useSingleSelectHooks = function (args) {
    var initialSelectedItem = args.initialSelectedItem, isDisabled = args.isDisabled, itemIsDisabled = args.itemIsDisabled, listItems = args.listItems, onChange = args.onChange, onInputChange = args.onInputChange, onInternalStateChange = args.onInternalStateChange, renderItemToString = args.renderItemToString, selectInput = args.selectInput, updateFilteredItems = args.updateFilteredItems;
    // Custom hook for the SingleSelect state reducer
    var comboboxStateReducer = (0, useSelectStateReducers_1.useSelectStateReducers)({
        callCloseMenu: function () { return closeMenu(); },
        callOpenMenu: function () { return openMenu(); },
        itemIsDisabled: itemIsDisabled,
        renderItemToString: renderItemToString,
        selectInput: selectInput,
        updateFilteredItems: updateFilteredItems,
    }).comboboxStateReducer;
    var useComboboxControlProps = (0, exports.useComboboxHook)({
        initialSelectedItem: initialSelectedItem,
        isDisabled: isDisabled,
        listItems: listItems,
        onChange: onChange,
        onInputChange: onInputChange,
        onInternalStateChange: onInternalStateChange,
        renderItemToString: renderItemToString,
        stateReducer: comboboxStateReducer,
    }).useComboboxControlProps;
    var closeMenu = useComboboxControlProps.closeMenu, openMenu = useComboboxControlProps.openMenu;
    return {
        useComboboxControlProps: useComboboxControlProps,
    };
};
exports.useSingleSelectHooks = useSingleSelectHooks;
var useMultiSelectHooks = function (args) {
    var _a = args.initialSelectedItems, initialSelectedItems = _a === void 0 ? [] : _a, isDisabled = args.isDisabled, itemIsDisabled = args.itemIsDisabled, listItems = args.listItems, onChange = args.onChange, onInputChange = args.onInputChange, onInternalStateChange = args.onInternalStateChange, renderItemToString = args.renderItemToString, selectInput = args.selectInput, updateFilteredItems = args.updateFilteredItems, safelyCallItemToID = args.safelyCallItemToID;
    // Custom hook for the MultiSelect state reducers
    var _b = (0, useSelectStateReducers_1.useSelectStateReducers)({
        callAddSelectedItem: function (item) {
            var itemIndex = selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.findIndex(function (selectedItem) { return safelyCallItemToID(selectedItem) === safelyCallItemToID(item); });
            if (itemIndex !== -1) {
                removeSelectedItem(selectedItems[itemIndex]);
            }
            else {
                addSelectedItem(item);
            }
        },
        callOpenMenu: function () { return openMenu(); },
        callSelectItem: function (item) { return selectItem(item); },
        isMultiSelect: true,
        itemIsDisabled: itemIsDisabled,
        renderItemToString: renderItemToString,
        selectInput: selectInput,
        updateFilteredItems: updateFilteredItems,
    }), comboboxStateReducer = _b.comboboxStateReducer, multipleSelectionStateReducer = _b.multipleSelectionStateReducer;
    var _c = (0, downshift_1.useMultipleSelection)({
        initialSelectedItems: initialSelectedItems,
        onSelectedItemsChange: function (changes) {
            return (0, shared_1.sharedOnSelectedItemChange)(changes, isDisabled, onChange);
        },
        stateReducer: multipleSelectionStateReducer,
    }), getSelectedItemProps = _c.getSelectedItemProps, getDropdownProps = _c.getDropdownProps, addSelectedItem = _c.addSelectedItem, removeSelectedItem = _c.removeSelectedItem, selectedItems = _c.selectedItems, setSelectedItems = _c.setSelectedItems;
    var useComboboxControlProps = (0, exports.useComboboxHook)({
        isDisabled: isDisabled,
        isMultiSelect: true,
        listItems: listItems,
        onChange: onChange,
        onInputChange: onInputChange,
        onInternalStateChange: onInternalStateChange,
        renderItemToString: renderItemToString,
        stateReducer: comboboxStateReducer,
    }).useComboboxControlProps;
    var openMenu = useComboboxControlProps.openMenu, selectItem = useComboboxControlProps.selectItem;
    return {
        useComboboxControlProps: useComboboxControlProps,
        useMultipleSelectionControlProps: {
            addSelectedItem: addSelectedItem,
            getDropdownProps: getDropdownProps,
            getSelectedItemProps: getSelectedItemProps,
            removeSelectedItem: removeSelectedItem,
            selectedItems: selectedItems,
            setSelectedItems: setSelectedItems,
        },
    };
};
exports.useMultiSelectHooks = useMultiSelectHooks;
